<template>
    <CompassModal
        v-model:visible="showModal"
        size="large"
        :title="$t.__('AddressMap.map_and_route')"
        class="address-map"
        @closed="$emit('close')"
    >
        <template #default>
            <div class="dialog__default">
                <div class="dialog__default--formcontainer">
                    <!-- ROUTING FORM -->
                    <section class="mb-4">
                        <!-- ORIGIN INPUT-->
                        <div class="label-input">
                            <label for="">{{ $l10n.__('Définissez un point de départ') }}</label>
                            <algolia-input
                                :defaultValue="startPoint"
                                elementName="algolia-address"
                                placeType="address"
                                @bubble-address="captureAddress"
                            ></algolia-input>
                        </div>

                        <!-- DESTINATION SELECT -->
                        <div class="label-input">
                            <label for="">{{ $l10n.__("Définissez un point d'arrivée") }}</label>
                            <el-select
                                v-model="endAddressId"
                                class="wp-10"
                                :placeholder="$t.__('AddressMap.arrival_point')"
                                @change="handleSelectAddress"
                            >
                                <el-option
                                    v-for="(address, index) in availableAddresses"
                                    :key="index"
                                    :label="address.name"
                                    :value="address.id"
                                >
                                </el-option>
                            </el-select>
                        </div>

                        <!-- START BUTTON -->
                        <div class="mt-4">
                            <CompassTooltip
                                :disabled="!invalidSelectedAddress"
                                :content="$t.__('addressMap.invalid_selected_address')"
                                :arrow="false"
                            >
                                <CompassButton
                                    :label="$t.__('common.actions.search')"
                                    :disabled="
                                        !availableAddresses.length > 0 || invalidSelectedAddress
                                    "
                                    @click="startRouting()"
                                />
                            </CompassTooltip>
                        </div>
                    </section>

                    <!-- ADDRESSES CARDS-->
                    <h3 class="mt-0">{{ $l10n.__('Adresse(s) de la société') }}</h3>
                    <div class="ov-auto">
                        <addressMapCard
                            v-for="(address, index) in addresses"
                            ref="addressCard"
                            :key="index"
                            :address="address"
                            @select-address="selectAddress"
                        />
                    </div>
                </div>
                <div class="dialog__default--map">
                    <JawgMap
                        ref="jawgMap"
                        :addresses="addresses"
                        :selectedAddress="selectedAddress"
                        :origin="startPoint"
                        :destination="endPoint"
                    />
                </div>
            </div>
        </template>
    </CompassModal>
</template>

<script>
import AddressMapCard from './AddressMapCard.vue';
import JawgMap from './JawgMap.vue';
import AlgoliaInput from './inputs/AlgoliaInput.vue';

export default {
    components: {
        AddressMapCard,
        JawgMap,
        'algolia-input': AlgoliaInput,
    },
    props: {
        visible: {
            type: Boolean,
        },
        addresses: {
            type: Array,
        },
        corpAddress: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            showModal: this.visible,
            selectedAddress: {},
            endPoint: '',
            startPoint: '',
            endAddressId: '',
        };
    },
    computed: {
        availableAddresses() {
            return this.addresses.filter((address) => address.lat !== null && address.lng !== null);
        },
        invalidSelectedAddress() {
            return (
                this.selectedAddress?.geocode?.lat === null ||
                this.selectedAddress?.geocode?.lng === null
            );
        },
    },
    watch: {
        visible(newValue) {
            this.showModal = newValue;
        },
    },
    mounted() {
        this.selectedAddress =
            this.availableAddresses.find((address) => address.is_invoicing_address) ||
            this.availableAddresses.find((address) => address.is_delivery_address) ||
            this.availableAddresses.find(
                (address) => address.geocode?.lat !== null && address.geocode?.lng !== null,
            );
        this.startPoint =
            this.corpAddress === undefined
                ? ''
                : this.corpAddress.part1 + ', ' + this.corpAddress.town;
        this.endAddressId = this.selectedAddress?.id ?? '';
    },
    methods: {
        handleSelectAddress(idAddress) {
            const address = this.availableAddresses.find((address) => address.id === idAddress);
            if (address) {
                this.selectAddress(
                    address,
                    this.$refs.addressCard.find((el) => el.address.id === idAddress),
                );
            }
        },
        selectAddress(address, el) {
            for (let i = 0; i < this.$refs.addressCard.length; i++) {
                this.$refs.addressCard[i].selected = false;
            }
            el.selected = true;
            this.endAddressId = address.id;
            this.selectedAddress = address;
            this.$refs.jawgMap.setZoom(address);
        },
        startRouting() {
            if (this.availableAddresses.length > 0) {
                this.selectedAddress = this.availableAddresses.find(
                    (address) => address.id == this.endAddressId,
                );
                this.endPoint =
                    this.selectedAddress.address_line_1 + ', ' + this.selectedAddress.city;
                this.$nextTick(() => {
                    this.$refs.jawgMap.startRouting();
                });
            }
        },
        captureAddress(data) {
            this.startPoint = data.label;
        },
    },
};
</script>

<style lang="scss">
.address-map {
    .dialog {
        &__default {
            display: flex;
            justify-content: space-between;
            padding-bottom: 24px;

            &--formcontainer {
                width: 304px;
                margin-right: 16px;
            }

            &--map {
                width: 100%;
                height: 600px;
            }
        }
    }
}
</style>
